import SmallImagesNewsCard from "../../Helper/SmallImagesNewsCard";
import Title from "../../Helper/Title";

const RightComponent = ({ rightSideData, title }) => {
  const design = (
    <>
      <div className="mb-5">
        <Title showDot className="!text-[20px] !leading-[22px]">
          {title}
        </Title>
      </div>

      <div className="space-y-5">
        {rightSideData?.map((data, index) => (
          <SmallImagesNewsCard
            subtitleAs="h3"
            key={index}
            title="खेल"
            subtitle={data?.title}
            image={data?.thumbnail}
            // media_details={data?.media_details?.sizes}
            href={data?.permalink}
            imageAlt={data?.thumbnail_alt}
            isVideo={data?.is_video}
            showDot
            showMainTitle
            subtitleProps={{
              size: "16px",
              lineHeight: "22px",
              className: "cursor-pointer",
            }}
            loading="lazy"
            fetchPriority="low"
            decoding="async"
          />
        ))}
      </div>
    </>
  );
  return design;
};

export default RightComponent;
